var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"frameBorder":"0","src":_vm.frameSrc,"width":_vm.containerWidth,"height":_vm.containerHeight}})
}
var staticRenderFns = []

export { render, staticRenderFns }